import type { AnimationEvent } from "react";

export function releaseWillChange(
  event: Pick<AnimationEvent<HTMLElement>, "animationName" | "target" | "currentTarget">,
  expected: string,
): void {
  if (event.animationName !== expected || event.target !== event.currentTarget) return;
  (event.currentTarget as HTMLElement).style.willChange = "auto";
}
